
export const filteredAccessPermissions = (accessPermissions) => {
  return accessPermissions
    .filter(item => item.permission === 1)
    .map(route => ({
      path: route.path,
      name: route.menu_name,
    }))
}
